import { ENationality } from '@constants';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

type Props = {
  value?: ENationality;
  onChange?: (value: ENationality) => void;
  disabled?: boolean;
  placeholder?: string;
};

export const NationalitySelector: React.FC<Props> = ({
  value,
  onChange,
  disabled,
  placeholder
}) => {
  const { t } = useTranslation('DefaultTranslations');
  const options = Object.values(ENationality).map(nationality => ({
    label: t(nationality),
    value: nationality
  }));
  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      showSearch
      allowClear
      disabled={disabled}
      placeholder={placeholder}
    />
  );
};
